import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { RiArrowDropDownLine, RiCheckLine, RiCloseLine } from 'react-icons/ri';

import { translate } from '@/i18n/src/locales';
import Card from '@/components/Card';
import TitlePage from '@/components/TitlePage';
import Input from '@/components/Forms/Input';
import InputCEP from '@/components/Forms/InputCEP';
import Radio from '@/components/Forms/Radio';
import SelectOne from '@/components/Forms/SelectOne';
import Erro from '@/pages/Erro';

import { showAlert } from '@/store/actions/theme';
import { api } from '@/services/api';

import { ContainerLoader, HeaderAdress, ArrowCollapse, CollapseItem } from './styles';

function PoleView() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);

  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [statusOptions, setStatusOptions] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [canChangeStatus, setCanChangeStatus] = useState(false);

  const [isRequestingChange, setIsRequestingChange] = useState(false);
  const [changeRequestText, setChangeRequestText] = useState('');

  const [radioPerson, setRadioPerson] = useState([
    { label: translate('physicalPerson'), selected: false, type: 'F' },
    { label: translate('legalPerson'), selected: true, type: 'J' },
  ]);

  const [planSelectedId, setPlanSelectedId] = useState('0');
  const [poleName, setPoleName] = useState('');
  const [admName, setAdmName] = useState('');
  const [admEmail, setAdmEmail] = useState('');
  const [cpf, setCPF] = useState('');
  const [rg, setRG] = useState('');
  const [telefone, setTelefone] = useState('');
  const [celular, setCelular] = useState('');
  const [cnpj, setCNPJ] = useState('');
  const [ie, setIE] = useState('');
  const [nomeFantasia, setNomeFantasia] = useState('');
  const [razaoSocial, setRazaoSocial] = useState('');

  const [endMain, setEndMain] = useState({ cep: '', log: '', num: '', bai: '', cid: '', est: '' });
  const [endShipping, setEndShipping] = useState({ cep: '', log: '', num: '', bai: '', cid: '', est: '' });
  const [endPayment, setEndPayment] = useState({ cep: '', log: '', num: '', bai: '', cid: '', est: '' });

  const [openCollapseMain, setOpenCollapseMain] = useState(true);
  const [openCollapseShipping, setOpenCollapseShipping] = useState(false);
  const [openCollapsePayment, setOpenCollapsePayment] = useState(false);

  const getV = (obj, key) => {
    if (!obj) return '';
    const cap = key.charAt(0).toUpperCase() + key.slice(1);
    const low = key.charAt(0).toLowerCase() + key.slice(1);
    return obj[cap] ?? obj[low] ?? obj[key] ?? '';
  };

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const [resPolo, resStatus] = await Promise.all([
          api.get(`/Polo/GetPoloById/${id}`),
          api.get(`/Franqueadora/GetStatusPolosByFranqueadora`)
        ]);

        const d = resPolo.data;
        if (!d) { setHasError(true); return; }

        const idPessoaTipo = getV(d, 'idPessoaTipo');
        const isPF = Number(idPessoaTipo) === 2;

        setRadioPerson([
          { label: translate('physicalPerson'), selected: isPF, type: 'F' },
          { label: translate('legalPerson'), selected: !isPF, type: 'J' },
        ]);

        setAdmName(getV(d, 'nomeAdministrador'));
        setAdmEmail(getV(d, 'emailAdministrador'));
        setRazaoSocial(getV(d, 'razaoSocial'));
        setTelefone(getV(d, 'telefone'));
        setCelular(getV(d, 'celular'));
        setPlanSelectedId(getV(d, 'idFranqueadoraPlano')?.toString() || '0');

        const doc = getV(d, 'cnpJ_CPF') || d['CNPJ_CPF'] || '';
        const docIe = getV(d, 'iE_RG') || d['IE_RG'] || '';

        if (isPF) {
          setPoleName(getV(d, 'nomePolo'));
          setCPF(doc);
          setRG(docIe);
        } else {
          setNomeFantasia(getV(d, 'nomePolo'));
          setCNPJ(doc);
          setIE(docIe);
        }

        const fmtAddr = (objName) => {
          const obj = d[objName] || d[objName.charAt(0).toLowerCase() + objName.slice(1)];
          return {
            cep: getV(obj, 'CEP')?.trim() || '',
            log: getV(obj, 'logradouro')?.trim() || '',
            num: getV(obj, 'numero')?.trim() || '',
            bai: getV(obj, 'bairro')?.trim() || '',
            cid: getV(obj, 'cidade')?.trim() || '',
            est: getV(obj, 'estado')?.trim() || '',
          };
        };

        setEndMain(fmtAddr('EnderecoPrincipal'));
        setEndShipping(fmtAddr('EnderecoEntrega'));
        setEndPayment(fmtAddr('EnderecoCobranca'));

        const rawStatusList = resStatus.data || [];
        const statusObj = d['StatusPolo'] || d['statusPolo'];
        const idStatusAtual = getV(statusObj, 'idStatus');
        const descAtual = getV(statusObj, 'descricao')?.trim() || 'Ativo';
        const statusAtualObj = { value: idStatusAtual, label: descAtual };

        setCanChangeStatus(rawStatusList.length > 0);

        const formattedList = rawStatusList.map(s => ({
          value: s.IdStatus,
          label: s.Descricao?.trim()
        }));

        let finalOpts = [];
        if (rawStatusList.length === 0) {
          finalOpts = [statusAtualObj];
        } else {
          const exists = formattedList.find(o => Number(o.value) === Number(idStatusAtual));
          finalOpts = exists ? formattedList : [statusAtualObj, ...formattedList];
        }

        setStatusOptions(finalOpts);
        setCurrentStatus(statusAtualObj);
        setPendingStatus(statusAtualObj);

      } catch (e) {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };
    loadInitialData();
  }, [id]);

  const handleConfirmStatusChange = async () => {
    try {
      await api.put(`/Polo/AtualizaStatusPolo`, null, {
        params: {
          idPolo: id,
          idStatus: pendingStatus.value,
          idFranqueadora: user.IdFranqueadora
        }
      });
      setCurrentStatus(pendingStatus);
      dispatch(showAlert({ type: 'success', message: translate('statusUpdatedSuccessfully'), time: 3000 }));
    } catch (e) {
      setPendingStatus(currentStatus);
      dispatch(showAlert({ type: 'danger', message: translate('unableToProcessRequest'), time: 4000 }));
    }
  };

  const handleSubmitChangeRequest = async () => {
    if (!changeRequestText.trim()) {
      dispatch(showAlert({ type: 'warning', message: translate('pleaseDescribeWhatYouWantToChange'), time: 3000 }));
      return;
    }
    setIsSubmitting(true);
    try {
      const isPF_local = radioPerson.find(i => i.selected)?.type === 'F';
      const payload = {
        IdFranqueadoraPlano: parseInt(planSelectedId),
        NomePolo: isPF_local ? poleName : nomeFantasia,
        EmailAdministrador: admEmail,
        NomeAdministrador: admName,
        RazaoSocial: razaoSocial,
        CNPJ_CPF: isPF_local ? cpf : cnpj,
        IE_RG: isPF_local ? rg : ie,
        IdPessoaTipo: isPF_local ? 2 : 1,
        Telefone: telefone,
        Celular: celular,
        EnderecoPrincipal: { CEP: endMain.cep, Logradouro: endMain.log, Numero: endMain.num, Bairro: endMain.bai, Cidade: endMain.cid, Estado: endMain.est },
        MensagemEdicao: changeRequestText
      };
      await api.post('/Polo/CriarTicketEdicaoPolo', payload);
      dispatch(showAlert({ type: 'success', message: translate('requestSentSuccessfully'), time: 4000 }));
      setIsRequestingChange(false);
      setChangeRequestText('');
    } catch (e) {
      dispatch(showAlert({ type: 'danger', message: translate('unableToProcessRequest'), time: 5000 }));
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderAddr = (title, open, setOpen, v) => (
    <Card>
      <HeaderAdress onClick={() => setOpen(!open)}>
        <div className="titulo"><span>{title}</span></div>
        <ArrowCollapse open={open}><RiArrowDropDownLine size={30} /></ArrowCollapse>
      </HeaderAdress>
      <CollapseItem open={open} isOpen={open}>
        <div className="form" style={{ padding: '10px 0' }}>
          <Row>
            <Col xs={12} md={3}>{user.Linguagem === 'pt_BR' ? <InputCEP label={translate('cep')} value={v.cep} /> : <Input label={translate('cep')} value={v.cep} />}</Col>
            <Col xs={12} md={7}><Input label={translate('street')} value={v.log} /></Col>
            <Col xs={12} md={2}><Input label={translate('shortNumber')} value={v.num} /></Col>
          </Row>
          <Row>
            <Col xs={12} md={4}><Input label={translate('neighborhood')} value={v.bai} /></Col>
            <Col xs={12} md={5}><Input label={translate('city')} value={v.cid} /></Col>
            <Col xs={12} md={3}><Input label={translate('uf')} value={v.est} /></Col>
          </Row>
        </div>
      </CollapseItem>
    </Card>
  );

  if (isLoading) return <ContainerLoader>{translate('fetchingPoleInfo')}</ContainerLoader>;
  if (hasError) return <Erro />;

  const isPF_Active = radioPerson.find(i => i.selected)?.type === 'F';
  const hasStatusChanged = pendingStatus && currentStatus && pendingStatus.value !== currentStatus.value;

  return (
    <>
      <Helmet><title>{translate('poleView')}</title></Helmet>
      <TitlePage title={translate('poleView')} />

      <Card>
        <Row style={{ marginBottom: '20px' }}>
          <Col xs={12}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px' }}>
              <div style={{ width: '300px', position: 'relative' }}>
                <SelectOne
                  label={translate('poleStatus')}
                  options={statusOptions}
                  value={pendingStatus}
                  change={setPendingStatus}
                  disabled={!canChangeStatus}
                />
                {!canChangeStatus && (
                  <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 5, cursor: 'default' }} />
                )}
              </div>
              {hasStatusChanged && (
                <div style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
                  <button type="button" className="btn btn-success" style={{ height: '35px', width: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }} onClick={handleConfirmStatusChange}>
                    <RiCheckLine size={20} />
                  </button>
                  <button type="button" className="btn btn-danger" style={{ height: '35px', width: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }} onClick={() => setPendingStatus(currentStatus)}>
                    <RiCloseLine size={20} />
                  </button>
                </div>
              )}
            </div>
          </Col>
        </Row>

        <fieldset disabled style={{ border: 'none', padding: 0 }}>
          <div style={{ paddingBottom: '15px', pointerEvents: 'none', cursor: 'default' }}><Radio items={radioPerson} /></div>
          <Row>
            <Col xs={12} md={6}><Input label={translate('adminName')} value={admName} /></Col>
            <Col xs={12} md={6}><Input label={translate('adminEmail')} value={admEmail} /></Col>
          </Row>
          <Row><Col xs={12}><Input label={isPF_Active ? translate('poleName') : translate('nomeFantasia')} value={isPF_Active ? poleName : nomeFantasia} /></Col></Row>
          <Row><Col xs={12}><Input label={translate('razaoSocial')} value={razaoSocial} /></Col></Row>
          <Row>
            <Col xs={12} md={6}><Input label={isPF_Active ? translate('cpf') : translate('cnpj')} value={isPF_Active ? cpf : cnpj} /></Col>
            <Col xs={12} md={6}><Input label={isPF_Active ? translate('rg') : translate('ie')} value={isPF_Active ? rg : ie} /></Col>
          </Row>
          <Row>
            <Col xs={12} md={6}><Input label={translate('telefone')} value={telefone} /></Col>
            <Col xs={12} md={6}><Input label={translate('celular')} value={celular} /></Col>
          </Row>
        </fieldset>
      </Card>

      <fieldset disabled style={{ border: 'none', padding: 0 }}>
        {renderAddr(translate('addressMain'), openCollapseMain, setOpenCollapseMain, endMain)}
        {renderAddr(translate('deliveryAddress'), openCollapseShipping, setOpenCollapseShipping, endShipping)}
        {renderAddr(translate('billingAddress'), openCollapsePayment, setOpenCollapsePayment, endPayment)}
      </fieldset>

      <div style={{ marginTop: '30px', marginBottom: '40px' }}>
        {!isRequestingChange ? (
          <button type="button" className="btn btn-primary" style={{ width: '100%', height: '45px', backgroundColor: '#17c671' }} onClick={() => setIsRequestingChange(true)}>{translate('requestChange')}</button>
        ) : (
          <Card>
            <h4>{translate('whatWouldYouLikeToChange')}</h4>
            <textarea style={{ width: '100%', minHeight: '100px', padding: '10px' }} value={changeRequestText} onChange={(e) => setChangeRequestText(e.target.value)} />
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '15px' }}>
              <button type="button" className="btn btn-default" onClick={() => setIsRequestingChange(false)}>{translate('cancel')}</button>
              <button type="button" className="btn btn-primary" disabled={isSubmitting} onClick={handleSubmitChangeRequest}>{isSubmitting ? translate('sending') : translate('sendRequest')}</button>
            </div>
          </Card>
        )}
      </div>
    </>
  );
}

export default PoleView;